import Icon from '@vromo/ui/components/FontAwesome';
import { css } from 'emotion';
import React, { memo } from 'react';
import colors from '../../../../../utils/colors';
import carIcon from '../../../../assets/car.png';
import styles from './orderProgressBar.style';
import { qaLabelTrackingLink } from '../../../../../../../common-qa-labels/tracking-link';

interface Props {
    progress: number;
}

const activeColor = colors.black;
const inactiveColor = colors.border;

const IconCircle = ({ isActive, icon }: { isActive: boolean; icon: string }) => (
    <div
        style={{
            ...styles.iconCircle,
            backgroundColor: isActive ? activeColor : inactiveColor
        }}>
        <Icon xs icon={icon} color={isActive ? colors.white : activeColor} />
    </div>
);

const OrderProgressBar = ({ progress }: Props): React.ReactElement => (
    <div style={styles.container} data-testid={qaLabelTrackingLink.orderProgressBar}>
        <div style={styles.barContainer}>
            <div
                className={css`
                    transition: width 0.5s ease;
                `}
                style={{
                    ...styles.barFill,
                    width: `${progress}%`,
                    backgroundColor: activeColor
                }}>
                {progress < 100 && <img src={carIcon} style={styles.carIcon} />}
            </div>
        </div>

        <div style={styles.iconCircleContainer}>
            <IconCircle isActive={true} icon={'building'} />
            <IconCircle isActive={progress >= 32} icon={'shopping-bag'} />
            <IconCircle isActive={progress >= 65} icon={'home'} />
            <IconCircle isActive={progress >= 100} icon={'check'} />
        </div>
    </div>
);

export default memo(OrderProgressBar);
